import React from "react";
import Image from "next/image";
import classNames from "classnames";
import { getFormattedDateParts } from "@entities/blog";
import { RouterConfig } from "@shared/lib/routerConfig";
import { SpriteIcon } from "@shared/ui/SpriteIcon";
import { BlogCardProps } from "./types";
import classes from "./blog-card.module.scss";

export const BlogCard = ({
    title,
    date,
    slug,
    views,
    image,
    authorName = "Автор статьи",
    avatarLink,
    withBorder,
    hideAuthor = false
}: BlogCardProps) => {
    const { date: formattedDate, time: formattedTime } = getFormattedDateParts(date);

    return (
        <a href={`${RouterConfig.BLOG}/${slug}`} className={classes.CardLink}>
            <article
                className={classNames(classes["blog-card"], {
                    [classes["blog-card__border"]]: withBorder
                })}
            >
                <div className={classes["blog-card__wrapper"]}>
                    <Image
                        className={classes["blog-card__image"]}
                        src={image}
                        alt={title}
                        fill={true}
                        sizes="(max-width: 900px) 50vw, 370px"
                    />
                </div>
                <div className={classes["blog-card__content"]}>
                    <div className={classes["blog-card__title"]}>{title}</div>
                    <div className={classes["blog-card__details"]}>
                        {!hideAuthor && (
                            <Image
                                className={classes["blog-card__avatar"]}
                                src={avatarLink}
                                alt={authorName}
                                width={57}
                                height={57}
                            />
                        )}
                        <div className={classes["blog-card__info"]}>
                            {!hideAuthor && (
                                <span className={classes["blog-card__author"]}>{authorName}</span>
                            )}
                            <div className={classes["blog-card__info--row"]}>
                                <span className={classes["blog-card__date"]}>
                                    {formattedDate}
                                    <span className={classes["blog-card__time"]}>
                                        , {formattedTime}
                                    </span>
                                </span>
                                <span className={classes["blog-card__divider"]}>|</span>
                                <div className={classes["blog-card__views"]}>
                                    <SpriteIcon
                                        className={classes["blog-card__views--icon"]}
                                        section={"blog"}
                                        name={"views"}
                                    />
                                    {views}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </article>
        </a>
    );
};